<template lang="pug">
  .bh-wrapper
    RadioSlider.slider(
      :items="optionsData.items",
      :current="optionsData.items.findIndex(i => i.id === optionsData.selected.id)",
      @selected="onSelectOption"
    )

    .flags
      .flags__checkbox
        PCheckbox(name="ultimoDiaInclusive", label="Considerar (inclusive) a data de baixa no cálculo da baixa de banco de horas" v-model="ultimoDiaInclusive")
      .flags__icone-de-informacao.icon-ptt-icons-info(style="font-size: 22px;")

      uiv-popover(
        target=".flags__icone-de-informacao"
        trigger="hover"
        placement="top"
      )
        div(slot="popover")
          span Ao selecionar essa opção, os eventos que acontecerem na data da baixa de banco de horas serão considerados no pagamento da baixa. Caso contrário, serão considerados os eventos que acontecerem até o dia anterior a baixa.

    template(v-if="optionsData.selected.id === 'whb_closer'")
      h3 Observações
      p
        | Data inicial será a 'data de baixa' e a data final será a 'data de pagamento da baixa'

    template(v-if="optionsData.selected.id === 'remove_whb_closer'")
      h3 Observações
      p
        | Será removido a última baixa de cada {{$ws('employee')}}.

    PButton(size="md" block color="success" @click="save" :loading="saving") Salvar

</template>

<script>
export default {
  name: 'BH',
  props: {
    saveParams: {type: Object, required: true},
    options: {type: Array, required: true}
  },
  created () {
    this.optionsData.items = this.options
    this.optionsData.selected = this.options[0]
  },
  data () {
    return {
      ultimoDiaInclusive: false,
      saving: false,
      optionsData: {
        selected: null,
        items: []
      }
    }
  },
  methods: {
    async save (option) {
      this.saving = true

      try {
        const result = await this.$API.fastRegister.save({
          ...this.saveParams,
          option: this.optionsData.selected.id,
          extra: {
            ultimoDiaInclusive: this.ultimoDiaInclusive
          }
        })
        this.$checkUserFiles()
        this.$swal({
          type: 'success',
          text: result.data?.success ? result.data.success : 'Mudanças aplicadas com sucesso'
        })
      } catch (e) {
        this.$swal({
          type: 'error',
          text: e.data?.error ? e.data.error : 'Não foi possivel aplicar as mudanças'
        })
      }

      this.saving = false
    },
    onSelectOption (item) {
      this.optionsData.selected = item
    }
  }
}
</script>

<style scoped lang="scss">
.bh-wrapper {
  display: grid;
  grid-column-gap: 30px;
}

.flags {
  margin-top: 1rem;
  display: flex;

  &__icone-de-informacao {
    margin-left: 1rem
  }
}
</style>
